<div [ngClass]="{'tooltip' : true, 'closed': closed}">
    <ng-content></ng-content>
</div>